export class RolePermission {
    id?: string | null = null;
    permission: string | null = null;
    roleId: string | null = null;

    constructor(data?: Partial<RolePermission>) {
        Object.assign(this, data);
    }
}
